import Web3 from 'web3';
import Mount_ABI from './fightercontractabi.json';
import { FighterMOUNT_CONTRACT } from '../../../../config';

console.log("Mount_ABI is array:", Array.isArray(Mount_ABI), Mount_ABI.length);
console.log("FighterMOUNT_CONTRACT:", FighterMOUNT_CONTRACT);

const MULTIVAC_CHAIN_ID = 62621; // decimal

export async function RemountFunction({
    walletAddress,
    newTokenId,
    newCollectionAddress, // ERC721 address of the NEW NFT
    onStatus,
    onSuccess,
    onError
}) {
    try {
        if (!window.ethereum) throw new Error('MetaMask is not installed!');

        const web3 = new Web3(window.ethereum);

        onStatus('Validating user session...');
        if (!walletAddress) throw new Error("Missing wallet address.");

        // -- Switch to MultiVAC, and add if needed --
        onStatus('Switching to MultiVAC network...');
        const chainIdHex = `0x${MULTIVAC_CHAIN_ID.toString(16)}`;
        try {
            await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: chainIdHex }],
            });
        } catch (switchError) {
            if (switchError.code === 4902 || (switchError.data && switchError.data.originalError && switchError.data.originalError.code === 4902)) {
                onStatus('MultiVAC not found. Adding MultiVAC to MetaMask...');
                try {
                    await window.ethereum.request({
                        method: 'wallet_addEthereumChain',
                        params: [{
                            chainId: chainIdHex,
                            chainName: 'MultiVAC',
                            rpcUrls: ['https://rpc.mtv.ac'],
                            nativeCurrency: {
                                name: 'MTV',
                                symbol: 'MTV',
                                decimals: 18
                            },
                            blockExplorerUrls: ['https://e.mtv.ac/index.html']
                        }]
                    });
                    await window.ethereum.request({
                        method: 'wallet_switchEthereumChain',
                        params: [{ chainId: chainIdHex }],
                    });
                } catch (addError) {
                    throw new Error('Failed to add MultiVAC network to MetaMask. Please add it manually.');
                }
            } else {
                throw switchError;
            }
        }

        // Step 3: Get account
        onStatus('Fetching wallet address...');
        const accounts = await web3.eth.getAccounts();
        const account = accounts[0];
        if (account.toLowerCase() !== walletAddress.toLowerCase())
            throw new Error("Wallet mismatch. Please select the correct account in MetaMask.");

        // Step 4: Check new NFT ownership & approval
        const ERC721_ABI = [
            { "constant": true, "inputs": [{ "name": "tokenId", "type": "uint256" }], "name": "ownerOf", "outputs": [{ "name": "", "type": "address" }], "type": "function" },
            { "constant": true, "inputs": [{ "name": "tokenId", "type": "uint256" }], "name": "getApproved", "outputs": [{ "name": "", "type": "address" }], "type": "function" },
            { "constant": false, "inputs": [{ "name": "to", "type": "address" }, { "name": "tokenId", "type": "uint256" }], "name": "approve", "outputs": [], "type": "function" }
        ];
        const newNftContract = new web3.eth.Contract(ERC721_ABI, newCollectionAddress);

        onStatus('Verifying new NFT ownership...');
        const nftOwner = await newNftContract.methods.ownerOf(newTokenId).call();
        if (nftOwner.toLowerCase() !== account.toLowerCase())
            throw new Error("You are not the owner of the new NFT!");

        onStatus('Checking approval for new NFT...');
        const approved = await newNftContract.methods.getApproved(newTokenId).call();
        const gasPrice = await web3.eth.getGasPrice();

        if (approved.toLowerCase() !== FighterMOUNT_CONTRACT.toLowerCase()) {
            onStatus('Approving new NFT for transfer...');
            const approveData = newNftContract.methods.approve(FighterMOUNT_CONTRACT, newTokenId).encodeABI();
            const approveTx = {
                from: account,
                to: newCollectionAddress,
                gas: 100000,
                gasPrice: gasPrice,
                data: approveData
            };
            await web3.eth.sendTransaction(approveTx);
        } else {
            onStatus('New NFT already approved for transfer.');
        }

        // Step 5: Call remount() on the FighterMount contract (legacy)
        if (!FighterMOUNT_CONTRACT || typeof FighterMOUNT_CONTRACT !== 'string' || !FighterMOUNT_CONTRACT.startsWith('0x') || FighterMOUNT_CONTRACT.length !== 42) {
            throw new Error("Contract address not specified or invalid at runtime!");
        }
        if (!Mount_ABI || !Array.isArray(Mount_ABI) || Mount_ABI.length === 0) {
            throw new Error("Mount_ABI not loaded correctly at runtime!");
        }
        const mountContract = new web3.eth.Contract(Mount_ABI, FighterMOUNT_CONTRACT);

        onStatus('Remounting NFT on chain...');
        const gasEstimate = await mountContract.methods.remount(newCollectionAddress, newTokenId).estimateGas({ from: account });
        const gasLimit = Number(gasEstimate) + 50000; // Convert to Number before adding!
        const data = mountContract.methods.remount(newCollectionAddress, newTokenId).encodeABI();
        const txObject = {
            from: account,
            to: FighterMOUNT_CONTRACT,
            gas: gasLimit,
            gasPrice: gasPrice,
            data: data
        };
        console.log("TX OBJECT", txObject); // Should show legacy fields only!
        await web3.eth.sendTransaction(txObject);

        onStatus('Fighter remounted successfully! ');
        setTimeout(() => onSuccess && onSuccess(), 1200);

    } catch (err) {
        onError && onError(err.message || "An error occurred during remounting.");
    }
}
